import { createSelector } from 'reselect';

const getDict = (state) => {
    const {
        config: {
            dictionary = {}
        } = {}     
    } = state;
    
   
    return dictionary;
};

export const getDictionary = createSelector(
    [getDict],
    (
        dictionary
    ) => (
        dictionary
    )
);
